<template>
  <div class="card-report-small">
    <div class="info-block">
      <div class="report-row">
        <!-- プロジェクト画像 -->
        <b-card-img
          v-bind:src="projectImageUrl"
          class="project-icon"
          crossorigin="use-credentials"
        />
        <!-- 報告書タイトル -->
        <span class="report-title">
          {{ reportTitle }}
        </span>
      </div>
      <div class="info-row">
        <!-- 報告者 -->
        <span class="name">{{ userName }}</span>
        <!-- 報告日時 -->
        <span class="date">{{ updateAtForDisplay }}</span>
      </div>
    </div>
    <div class="detail-block">
      <!-- 詳細リンク -->
      <span
        class="detail-link"
        v-on:click="$_onClickDetail"
        v-t="'appCardReportSmall.detail'"
      />
    </div>
  </div>
</template>

<script>
import { RestApiClient } from 'ifield-core-components'
import moment from 'moment'
import { DATE_FORMAT_SLASH, TIME_FORMAT_MINUTE } from '@/constants.js'

const DATETIME_FORMAT = `${DATE_FORMAT_SLASH} ${TIME_FORMAT_MINUTE}`

export default {
  name: 'AppCardReportSmall',
  props: {
    /**
     * 報告書ID
     */
    id: {
      type: Number,
      default: null,
      required: true,
    },
    /**
     * 報告書プロジェクトID
     */
    reportProjectId: {
      type: Number,
      default: null,
    },
    /**
     * 報告書更新日時
     */
    updateAt: {
      type: [String, Date],
      default: null,
    },
    /**
     * 報告書タイトル
     */
    reportTitle: {
      type: String,
      default: '',
    },
    /**
     * ユーザー名
     */
    userName: {
      type: String,
      default: '',
    },
  },
  computed: {
    /**
     * 報告書プロジェクト画像のURL
     * @type {String}
     */
    projectImageUrl: function () {
      // ダウンロードファイルAPI
      const url = RestApiClient.createApiUrl('download_file')
      const params = url.searchParams
      this.reportProjectId && params.append('id', this.reportProjectId)
      params.append('report_project_image', 1)
      params.append('attach_file_type', 5)
      return url.toString()
    },
    /**
     * 表示用日時
     * @type {String}
     */
    updateAtForDisplay: function () {
      const m = moment(this.updateAt)
      if (!m.isValid()) return ''
      return m.format(DATETIME_FORMAT)
    },
  },
  methods: {
    /**
     * 詳細リンククリック時処理
     */
    $_onClickDetail: function () {
      /**
       * 詳細クリックイベント
       * @param {Number} id 対象チェックインID
       */
      this.$emit('detail-click', this.id)
    },
  },
}
</script>

<style lang="scss" scoped>
.card-report-small {
  max-width: 16rem;
  height: 5.5rem;
  display: grid;
  grid-template-columns: 1fr max-content;
  align-items: center;
  column-gap: 32px;
  font-size: $font-size-middle;
  padding: 8px;
  overflow: hidden;
  user-select: none;
}

.info-block {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
}

.report-row {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  align-items: center;
  column-gap: 8px;

  .project-icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }

  .report-title {
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.info-row {
  display: grid;
  grid-template-rows: 1fr max-content;
  grid-auto-columns: minmax(0, 1fr);
  justify-items: start;
  align-items: start;
  padding-left: 2px;

  .name {
    max-width: 100%;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .date {
    color: #959595;
    font-size: $font-size-small;
    line-height: 1;
  }
}

.detail-block {
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

.detail-link {
  color: #006d30;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
</style>
